import { useEffect, useState } from "react";
import { axiosInstanceWebsite } from "../services/instance";

/**
 * Feature gates resueltos por el backend (GET /feature-gates): UN flag de Flagr cuyo variant
 * attachment es un JSON {feature: boolean}. El backend es quien valida de verdad; esto solo
 * evita ofrecer UI de features apagadas.
 *
 * FAIL-SAFE: mientras carga o si falla, todo se considera apagado — una feature nueva jamás
 * aparece por un error de red.
 */
export type FeatureGates = Record<string, boolean>;

let cached: FeatureGates | null = null;
let inFlight: Promise<FeatureGates> | null = null;

const fetchGates = (): Promise<FeatureGates> => {
  if (cached) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = axiosInstanceWebsite
      .get<FeatureGates>("/feature-gates")
      .then((response) => {
        cached = response.data ?? {};
        return cached;
      })
      .catch(() => {
        // No se cachea el fallo: el próximo montaje reintenta.
        inFlight = null;
        return {};
      });
  }
  return inFlight;
};

export const useFeatureGates = (): FeatureGates => {
  const [gates, setGates] = useState<FeatureGates>(cached ?? {});

  useEffect(() => {
    let mounted = true;
    fetchGates().then((resolved) => {
      if (mounted) setGates(resolved);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return gates;
};
